import { GridCellColor } from '@/enums'
import { dump, tipologia_dump } from '@/model/qsadminapi/QsAdminApiModuleModel'
import { TipologiaDump } from '@/routes/dumps/Dump.enums'
import type { AxiosInstance } from 'axios'
import { CellPreparedEvent } from 'devextreme/ui/data_grid'
import saveAs from 'file-saver'

const getDumpFileName = (dumpToDownload: dump) => {
  const fallbackFileName = dumpToDownload.ded_Dis || `dump-${dumpToDownload.id}`
  return dumpToDownload.filename?.trim() || `${fallbackFileName}.zip`
}

export const downloadDump = async (client: AxiosInstance, dumpToDownload: dump) => {
  const fileName = getDumpFileName(dumpToDownload)
  const response = await client.get(`/api/dump/download?dumpId=${dumpToDownload.id}`, {
    headers: {
      'Content-Disposition': `attachment;filename=${fileName}`,
      'Content-Type': 'application/octet-stream',
    },
    responseType: 'arraybuffer',
  })
  saveAs(new Blob([response.data], { type: 'application/octet-stream' }), fileName)
}

export const onCellPrepared = (e: CellPreparedEvent) => {
  if (e.rowType === 'data') {
    const tipologie: tipologia_dump[] = e.data.tipologie
    if (tipologie && tipologie.length > 0) {
      if (e.column.dataField === 'gdi_peak' && e.value) {
        if (tipologie.find((tipologia: tipologia_dump) => tipologia.id === TipologiaDump['SATURAZIONE GDI']))
          e.cellElement.style.cssText = `${e.cellElement.style.cssText}color: black; background-color: ${GridCellColor.LIGHTGRREN}`
      }
      if (e.column.dataField === 'session_uptime' && e.value) {
        if (tipologie.find((tipologia: tipologia_dump) => tipologia.id === TipologiaDump['SATURAZIONE MEMORIA']))
          e.cellElement.style.cssText = `${e.cellElement.style.cssText}color: black; background-color: ${GridCellColor.PLUM}`
      }
    }

    if (e.column.dataField === 'stato.nome' && e.value) {
      switch (e.value) {
        case 'NUOVO': {
          e.cellElement.style.cssText = `${e.cellElement.style.cssText}color: black; background-color: ${GridCellColor.YELLOW}`

          break
        }
        case 'VISIONATO': {
          e.cellElement.style.cssText = `${e.cellElement.style.cssText}color: black; background-color: ${GridCellColor.ORANGE}`

          break
        }
        case 'ANALIZZATO': {
          e.cellElement.style.cssText = `${e.cellElement.style.cssText}color: black; background-color: ${GridCellColor.EMERALD}`
          break
        }
      }
    }

    if (e.column.dataField === 'app_version' && e.value) {
      if (e.data.app_available_update !== null && e.data.app_available_update !== e.value)
        e.cellElement.style.cssText = `${e.cellElement.style.cssText}color: black; background-color: ${GridCellColor.SALMON}`
    }
    if (e.column.dataField === 'app_hotfix' && e.value) {
      if (e.data.app_available_hotfix !== null && e.data.app_available_hotfix !== e.value)
        e.cellElement.style.cssText = `${e.cellElement.style.cssText}color: black; background-color: ${GridCellColor.SALMON}`
    }
    if (e.column.dataField === 'common_hotfix' && e.value) {
      if (e.data.common_available_hotfix !== null && e.data.common_available_hotfix !== e.value)
        e.cellElement.style.cssText = `${e.cellElement.style.cssText}color: black; background-color: ${GridCellColor.SALMON}`
    }
  }
}
